import { Component, DestroyRef, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatTab, MatTabChangeEvent, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { Container } from '../../../overview/models/container';
import { RoutingComponent } from '../../../../components/shipment-details/components/routing/routing.component';
import { CustomFieldsComponent } from '../../../../components/shipment-details/components/custom-fields/custom-fields.component';
import { LastEventComponent } from '../../../../components/shipment-details/components/last-event/last-event.component';
import { AllEventsComponent } from '../../../../components/shipment-details/components/all-events/all-events.component';
import { DetailsComponent } from './components/details/details.component';
import { catchError, NEVER, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ContainerDetailsService } from '../../services/container-details.service';
import { GoogleTagManagerService } from '../../../../services/google-tag-manager.service';
import { PurchaseOrderListComponent } from '../../../../components/purchase-order-list/purchase-order-list.component';

@Component({
  selector: 'app-container-details',
  standalone: true,
  templateUrl: './container-details.component.html',
  imports: [
    MatTab,
    MatTabGroup,
    MatTabLabel,
    RoutingComponent,
    CustomFieldsComponent,
    LastEventComponent,
    AllEventsComponent,
    DetailsComponent,
    PurchaseOrderListComponent
  ],
  styleUrl: './container-details.component.scss'
})
export class ContainerDetailsComponent implements OnChanges {
  @Input() containerId: string | null = null;
  @Input() isArchived = false;
  @Output() detailsClosed = new EventEmitter();
  container: Container | null = null;

  private containerDetailsService = inject(ContainerDetailsService);
  private destroyRef = inject(DestroyRef);
  private matSnackBar = inject(MatSnackBar);
  private gtmService = inject(GoogleTagManagerService);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['containerId'] && changes['containerId'].currentValue) {
      this.container = null;
      this.containerDetailsService
        .getContainerBy(this.containerId!, this.isArchived)
        .pipe(
          tap(container => (this.container = container)),
          catchError(error => {
            this.matSnackBar.open('Could not get the container details. Please try again.', 'x');
            console.error(error);
            return NEVER;
          }),
          takeUntilDestroyed(this.destroyRef)
        )
        .subscribe();
    }
  }

  onTabChange({ tab }: MatTabChangeEvent) {
    this.gtmService.pushEvent({
      event: 'container_details',
      type: {
        tab_viewed: tab.textLabel
      }
    });
  }
}
